<script>
    import {setContext} from 'svelte';
    import {abortableGet} from '../../../utils.js';
    import Table from './Table.svelte';
    import Header from './TableHead.svelte';
    import TableBody from './TableBody.svelte';
    import Footer from './TableFoot.svelte';
    import TableRow from './TableRow.svelte';
    import TableColumn from './TableColumn.svelte';
    import Pagination from './Pagination.svelte';

    import orderBy from 'lodash.orderby';
    import take from 'lodash.take';
    import drop from 'lodash.drop';

    export let onDataSuccess = () => {
    };
    export let onDataFail = () => {
    };
    export let columns = [];
    export let totalItems = 0;
    export let pageSize = 100;
    export let nextUrl = '';
    export let previousUrl = '';
    export let loading = false;
    export let reloadAfterAbort = false;
    export let params = '';
    export let dataUrl = '';

    let className = '';
    export {className as class};

    let data = [];
    let sortingFields = [];

    $: getData(params);

    let request = abortableGet();

    let currentPage = 1;

    export function getCurrentPage() {
        return currentPage;
    }

    async function onNextPage(totalPages) {
        currentPage = currentPage === totalPages ? currentPage : currentPage + 1;
        if (nextUrl) {
            await getData(null, null, nextUrl);
        }
    }

    async function onPreviousPage() {
        currentPage = currentPage === 1 ? 1 : currentPage - 1;
        if (previousUrl) {
            await getData(null, null, previousUrl)
        }
    }

    async function onGoTo(index) {
        currentPage = index;
        let offsetString = '';
        if (currentPage) {
            const offset = currentPage - 1;
            offsetString = offset ? `&offset=${offset * pageSize}` : '';
        }

        await getData(params, offsetString);
    }

    async function getData(params, offset, urlOverride) {
        let url = urlOverride;

        if (!url) {
            url = `${dataUrl}?${params}`;

            const ordering = sortingFields.map(f => {
                return `${f.direction === 'descending' ? '-' : ''}${f.key}`;
            });
            let orderBy = '';
            if (ordering.length) {
                orderBy = `&ordering=${ordering.join()}`;
            }

            if (orderBy) {
                url += orderBy;
            }

            if (offset) {
                url += offset;
            }

            if(pageSize){
                url += `&limit=${pageSize}`;
            }
        }

        data = [];

        try {
            if (loading) {
                request.abort();
                request = abortableGet();
            }
            loading = true;
            const resp = await request.fetch(url);

            if (resp.ok) {
                const json = await resp.json();
                totalItems = json.count;
                nextUrl = json.next;
                previousUrl = json.previous;
                data = json.results;
                data.forEach(element => {
                    element["page"] = currentPage;
                }); 
                onDataSuccess(data);
            }
            loading = false;
        } catch (e) {
            if (e.name === 'AbortError') {
                if (reloadAfterAbort) {
                    loading = true;
                }
            } else {
                loading = false;
            }
            onDataFail(e);
        }
    }

    async function sort(field, direction) {
        sortingFields = sortingFields.filter(f => f.key !== field);
        if (direction) {
            sortingFields.push({
                key: field,
                direction: direction
            });
        } else {
            sortingFields = sortingFields.filter(f => f.key !== field);
        }

        await getData(params)
    }

    setContext('sortable', {
        sort: sort
    });


</script>


<Table class="{className}">
    <slot name="header">
        <Header>
            <TableRow class="column-header">
                {#each columns.filter(c => !c.hidden) as col}
                    <TableColumn key="{col.key}" isHeader="{true}" width="{col.width}" headers="{col.headers}"
                                 sortable="{col.sortable}" onSort={sort}>{col.label}</TableColumn>
                {/each}
            </TableRow>
        </Header>
    </slot>
    <TableBody>
        <slot>
            {#each data as row}
                <TableRow>
                    {#each columns.filter(c => !c.hidden) as k}
                        <TableColumn headers={k.headers ? k.headers : false}>
                            {#if k.renderer}
                                <svelte:component this={k.renderer} {row} props="{k.props}"/>
                            {:else}
                                {row[k.key] ? row[k.key] : ''}
                            {/if}
                        </TableColumn>
                    {/each}
                </TableRow>
            {/each}
        </slot>
    </TableBody>
    <Footer>
        <TableRow class="footer-row bg-gray-300">
            <TableColumn colspan={columns.filter(n => !n.hidden).length + 1}>
                <div class="table-footer">
                    <Pagination
                            {pageSize}
                            {loading}
                            current={currentPage}
                            total={totalItems}
                            next={onNextPage}
                            previous={onPreviousPage}
                            goTo={onGoTo}></Pagination>

                </div>
            </TableColumn>
        </TableRow>
    </Footer>
</Table>

